import { render, staticRenderFns } from "./ReopenPageConfig.vue?vue&type=template&id=c333c28e&scoped=true"
import script from "./ReopenPageConfig.vue?vue&type=script&lang=ts"
export * from "./ReopenPageConfig.vue?vue&type=script&lang=ts"
import style0 from "./ReopenPageConfig.vue?vue&type=style&index=0&id=c333c28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c333c28e",
  null
  
)

export default component.exports